import React, { useState, useEffect, useContext, createContext } from 'react';
import {  onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config';

// import {
//   auth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   createUserWithEmailAndPassword,
//   setDoc,
//   doc,
//   db,
//   addDoc,
//   collection,
//   signOut,
//   onAuthStateChanged,
//   query,
//   where,
//   onSnapshot,
// } from '/Users/adityarouniyar/Desktop/convoai/src/firebase/config.js'; // adjust the path if needed


const AuthContext = createContext({ user: null, loading: true });

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(
            auth, 
            (user) => {
                setUser(user);
                setLoading(false);
            }, 
            (error) => {
                console.error("Auth state change error:", error);
                setUser(null);
                setLoading(false);
            }
        );
        
        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);

    const value = { user, loading };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;


// export const AuthContext = createContext({ user: null });

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   return (
//     <AuthContext.Provider value={{ user }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

